import { includes, find } from 'lodash';

const GENERIC_DOMAIN = 'geoserver/gwc/service/tms/';
const AT_SEPARATOR = '@EPSG';
const URL_CONSTANTS = [
  'geoserver/',
  '/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=',
  '&outputFormat=application%2Fjson',
  'wms?service=WMS&version=1.1.0&request=GetMap&layers=',
  '&styles=&bbox=',
  '&width=461&height=768&srs=EPSG:4326&format=application%2Fjson%3Btype%3Dgeojson'
];

/**
 * Transforms a TMS url into a GeoJSON.
 *
 * @param {object} arg - The object parameter.
 * @param {string} arg.url - The URL of the TMS.
 * @param {Array} arg.bbox - The bbox array.
 * @returns {object} An object containing the new url and the name of the layer to draw.
 * @throws {Error} If something goes wrong.
 */
const getGeoJSONURLFromTMS = ({ url, bbox }) => {
  let adaptedUrl = url;
  if (includes(url, GENERIC_DOMAIN)) {
    const split = url.split('/');
    const stringContainer = find(split, item => includes(item, AT_SEPARATOR));
    const colomPosition = stringContainer.search(':');
    const atPosition = stringContainer.search('@');
    if (colomPosition < atPosition) {
      const mainName = stringContainer.slice(0, colomPosition);
      const layerName = stringContainer.slice(colomPosition + 1, atPosition);
      const domainPosition = url.search(GENERIC_DOMAIN);
      const domain = url.slice(0, domainPosition);
      adaptedUrl = `${domain}${URL_CONSTANTS[0]}${mainName}${URL_CONSTANTS[1]}${mainName}:${layerName}${URL_CONSTANTS[2]}`;
    } else {
      const layerName = stringContainer.slice(0, atPosition);
      const domainPosition = url.search(GENERIC_DOMAIN);
      const domain = url.slice(0, domainPosition);
      adaptedUrl = `${domain}${URL_CONSTANTS[0]}${URL_CONSTANTS[3]}${layerName}${URL_CONSTANTS[4]}${bbox[1]},${bbox[0]},${bbox[3]},${bbox[2]}${URL_CONSTANTS[5]}`;
    }
  }
  return adaptedUrl;
};

export default getGeoJSONURLFromTMS;
